"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RestComponent = void 0;
var _react = _interopRequireWildcard(require("react"));
var _jsFileDownload = _interopRequireDefault(require("js-file-download"));
var _AlertingComponent2 = require("./AlertingComponent");
var _HomepageContext = require("./HomepageContext");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * RestComponent extends a AlertingComponent to provide secureJSONFetch:
 * 
 * secureJSONFetch() can be used to fetch data from the backend
 * secureFileUpload() can be used to upload a file to the backend
 * 
 * Subclasses must export themselves withCookies() so that the csrfToken can be retrieved
 *
 * No fetch method is expected to return a redirect, so if this occurs this indicates the session expired. 
 * In this case tell the HomePage that the session is expired
 * 
 */
var RestComponent = exports.RestComponent = /*#__PURE__*/function (_AlertingComponent) {
  function RestComponent(props) {
    var _this;
    _classCallCheck(this, RestComponent);
    _this = _callSuper(this, RestComponent, [props]);
    //The Homepage context, which contains a function pointer to set the session as expired
    _defineProperty(_this, "_csrfToken", void 0);
    //Any redirect should just return us to the homepage
    _defineProperty(_this, "_handleRedirect", function () {
      console.log("Session Expired");
      var homepage = _this.context; //homepage methods stored in the context

      if (homepage && homepage.sessionExpiredCallback)
        //has method
        homepage.sessionExpiredCallback();else window.location.reload();
    });
    /**
     * Call fetch securely, passing the Oauth2 bearer token and the CSRF token. The REST API is expected to return a 
     * json response or null (200 OK) or an error.
     * 
     * The backend will never redirect our fetch request except when our session has expired, so in that case, handle in manually.
     * 
     * The path can contain the full REST path plus query string, and it is encodeURI'ed.  To handle special query strings that need encodeURIComponent,
     * pass them instead in "queryString".  The query string is appended unaltered to the path.
     * 
     * @param {String} path the REST path to which a JSON response or null is returned, this can include queryString unless encodeURIComponent is required
     * @param {Object} options standard fetch options (headers are replaced). If body exists, json header is set to "application/json"
     * @param {Function} callback function to be called when fetch is complete (with the JSON response, or null if no response)
     * @param {Function} onError function to be called when an error occurs, the error message passed as a String
     * @param {String} queryString the query part which must already be URI encoded, appended to path with encoding (not required)
     */
    _defineProperty(_this, "secureJSONFetch", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(path) {
        var options,
          callback,
          onError,
          queryString,
          opts,
          offset,
          tz,
          method,
          uri,
          response,
          body,
          errorMessage,
          json,
          _json,
          _args = arguments;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
              callback = _args.length > 2 ? _args[2] : undefined;
              onError = _args.length > 3 ? _args[3] : undefined;
              queryString = _args.length > 4 && _args[4] !== undefined ? _args[4] : null;
              //Add the bearer token and csrf header to the options (CSRF not necessary for GET requests, but doesn't hurt)
              opts = _objectSpread(_objectSpread({}, options), {}, {
                credentials: 'include',
                headers: {
                  "X-XSRF-TOKEN": _this._csrfToken
                },
                redirect: "manual"
              }); //If a body exists, add the json header type
              if (options.body) {
                opts.headers["Content-Type"] = "application/json";
              }

              //Accept only json response
              opts.headers["Accept"] = "application/json";

              //Let the server know what timezone we are in (for actions that cause server to generate timestamps)
              //The time-zone offset is the difference, in minutes, between UTC and local time. Note that this means that the offset is positive if the local timezone is behind UTC and negative if it is ahead. For example, if your time zone is UTC+10 (Australian Eastern Standard Time), -600 will be returned.
              offset = new Date().getTimezoneOffset();
              opts.headers["timezone-offset"] = offset.toString();
              tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
              opts.headers["timezone"] = tz;
              _context.prev = 11;
              method = options.method ? options.method : "GET";
              uri = encodeURI(path);
              if (queryString !== null) uri = uri + queryString;
              console.log(method + ": " + uri);
              _context.next = 18;
              return fetch(uri, opts);
            case 18:
              response = _context.sent;
              if (!(response.type === "opaqueredirect")) {
                _context.next = 22;
                break;
              }
              _this._handleRedirect();
              return _context.abrupt("return");
            case 22:
              _context.next = 24;
              return response.text();
            case 24:
              body = _context.sent;
              if (response.ok) {
                _context.next = 31;
                break;
              }
              console.log("Server Error: " + response.status);
              errorMessage = "Unknown Error";
              if (body) {
                try {
                  json = JSON.parse(body);
                  if (json.message) {
                    errorMessage = json.message;
                  }
                } catch (parseError) {
                  //json parse error, not JSON, so report the server error
                  errorMessage = "Server Error: " + response.status;
                }
              }
              if (onError) {
                onError(errorMessage);
              }
              return _context.abrupt("return");
            case 31:
              if (callback) {
                if (body) {
                  try {
                    _json = JSON.parse(body); //this should parse properly, on success
                    callback(_json);
                  } catch (parseError) {
                    onError("Invalid response from server");
                  }
                } else {
                  callback(null);
                }
              }
              _context.next = 38;
              break;
            case 34:
              _context.prev = 34;
              _context.t0 = _context["catch"](11);
              console.log(_context.t0);
              if (onError) {
                onError("Request Failed: " + _context.t0.toString());
              }
            case 38:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[11, 34]]);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    /**
    * Call fetch securely, passing the Oauth2 bearer token and the CSRF token. The REST API is expected to 
    * periodically send a String indicating status of the processing. The string may include percent complete or other status information metric.
    * It's up to the server and client to agree on a format of the status.
    * 
    * When a progress string is received, the progressCallback is issued. 
    * 
    * The backend will never redirect our fetch request except when our session has expired, so in that case, handle in manually.
    * 
    * The path can contain the full REST path plus query string, and it is encodeURI'ed.  To handle special query strings that need encodeURIComponent,
    * pass them instead in "queryString".  The query string is appended unaltered to the path.
    * 
    * @param {String} path the REST path to which a JSON response or null is returned, this can include queryString unless encodeURIComponent is required
    * @param {Object} options standard fetch options (headers are replaced). If body exists, json header is set to "application/json"
    * @param {Function} progressCallback function to be called when fetch is complete (with the JSON response, or null if no response)
    * @param {Function} onError function to be called when an error occurs, the error message passed as a String
    * @param {String} queryString the query part which must already be URI encoded, appended to path with encoding (not required)
    */
    _defineProperty(_this, "secureFetchWithProgress", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(path) {
        var options,
          progressCallback,
          onError,
          queryString,
          opts,
          offset,
          tz,
          method,
          uri,
          response,
          status,
          _status,
          decoder,
          reader,
          _yield$reader$read,
          done,
          value,
          result,
          _args2 = arguments;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              options = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
              progressCallback = _args2.length > 2 ? _args2[2] : undefined;
              onError = _args2.length > 3 ? _args2[3] : undefined;
              queryString = _args2.length > 4 && _args2[4] !== undefined ? _args2[4] : null;
              //Add the bearer token and csrf header to the options (CSRF not necessary for GET requests, but doesn't hurt)
              opts = _objectSpread(_objectSpread({}, options), {}, {
                credentials: 'include',
                headers: {
                  "X-XSRF-TOKEN": _this._csrfToken
                },
                redirect: "manual"
              }); //If a body exists, add the json header type
              if (options.body) {
                opts.headers["Content-Type"] = "application/json";
              }

              //Let the server know what timezone we are in (for actions that cause server to generate timestamps)
              //The time-zone offset is the difference, in minutes, between UTC and local time. Note that this means that the offset is positive if the local timezone is behind UTC and negative if it is ahead. For example, if your time zone is UTC+10 (Australian Eastern Standard Time), -600 will be returned.
              offset = new Date().getTimezoneOffset();
              opts.headers["timezone-offset"] = offset.toString();
              tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
              opts.headers["timezone"] = tz;
              _context2.prev = 10;
              method = options.method ? options.method : "GET";
              uri = encodeURI(path);
              if (queryString !== null) uri = uri + queryString;
              console.log(method + ": " + uri);
              _context2.next = 17;
              return fetch(uri, opts);
            case 17:
              response = _context2.sent;
              if (!(response.type === "opaqueredirect")) {
                _context2.next = 21;
                break;
              }
              _this._handleRedirect();
              return _context2.abrupt("return");
            case 21:
              if (response.ok) {
                _context2.next = 26;
                break;
              }
              status = "Server Error: " + response.statusText;
              console.log(status);
              if (onError) {
                onError("Server Error: " + status);
              }
              return _context2.abrupt("return");
            case 26:
              if (!response.body) {
                _status = "Browser Unsupported for Progress";
                console.log(_status);
                if (onError) {
                  onError("Server Error: " + _status);
                }
              }
              decoder = new TextDecoder("utf-8");
              reader = response.body.getReader(); //create a stream reader for the response body
            case 29:
              if (!true) {
                _context2.next = 42;
                break;
              }
              _context2.next = 32;
              return reader.read();
            case 32:
              _yield$reader$read = _context2.sent;
              done = _yield$reader$read.done;
              value = _yield$reader$read.value;
              if (!done) {
                _context2.next = 38;
                break;
              }
              progressCallback(true, "Done");
              return _context2.abrupt("return");
            case 38:
              result = decoder.decode(value); //decode to text
              progressCallback(false, result);
              _context2.next = 29;
              break;
            case 42:
              _context2.next = 48;
              break;
            case 44:
              _context2.prev = 44;
              _context2.t0 = _context2["catch"](10);
              console.log(_context2.t0);
              if (onError) {
                onError("Request Failed: " + _context2.t0.toString());
              }
            case 48:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[10, 44]]);
      }));
      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }());
    /**
     * Uploads a multipart file for processing and monitors its progress. 
     * 
     * Call POST REST method securely, passing the Oauth2 bearer token and the CSRF token. The REST API is expected to 
     * periodically send a String indicating status of the processing. The string may include percent complete or other status information metric.
     * It's up to the server and client to agree on a format of the status.
     * 
     * When a progress string is received, the progressCallback is issued. 
     * 
     * @param {String} path the REST path to which the file is POSTed.
     * @param {File} file to upload
     * @param {Function} progressCallback function to be called when progress is updated, passes a boolean (true when done) and a status String
     * @param {Function} onError function to be called when an error occurs, the error message passed as a String
     * @param {String} queryString the query part which must already be URI encoded, appended to path with encoding (not required)
     */
    _defineProperty(_this, "secureFileUpload", /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(path, file, progressCallback, onError) {
        var queryString,
          formData,
          opts,
          offset,
          tz,
          uri,
          response,
          status,
          _status2,
          decoder,
          reader,
          _yield$reader$read2,
          done,
          value,
          result,
          _args3 = arguments;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              queryString = _args3.length > 4 && _args3[4] !== undefined ? _args3[4] : null;
              //Form data has the file as a multipart 
              formData = new FormData();
              formData.append('file', file);

              //Add the bearer token and csrf header to the options 
              opts = {
                credentials: 'include',
                headers: {
                  "X-XSRF-TOKEN": _this._csrfToken
                },
                method: "POST",
                body: formData,
                redirect: "manual"
              }; //Let the server know what timezone we are in (for actions that cause server to generate timestamps)
              //The time-zone offset is the difference, in minutes, between UTC and local time. Note that this means that the offset is positive if the local timezone is behind UTC and negative if it is ahead. For example, if your time zone is UTC+10 (Australian Eastern Standard Time), -600 will be returned.
              offset = new Date().getTimezoneOffset();
              opts.headers["timezone-offset"] = offset.toString();
              tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
              opts.headers["timezone"] = tz;
              _context3.prev = 8;
              uri = encodeURI(path);
              if (queryString !== null) uri = uri + queryString;
              console.log("File Upload: " + uri);
              _context3.next = 14;
              return fetch(uri, opts);
            case 14:
              response = _context3.sent;
              if (!(response.type === "opaqueredirect")) {
                _context3.next = 18;
                break;
              }
              _this._handleRedirect();
              return _context3.abrupt("return");
            case 18:
              if (response.ok) {
                _context3.next = 23;
                break;
              }
              status = "Server Error: " + response.statusText;
              console.log(status);
              if (onError) {
                onError("Server Error: " + status);
              }
              return _context3.abrupt("return");
            case 23:
              if (!response.body) {
                _status2 = "Browser Unsupported for Upload";
                console.log(_status2);
                if (onError) {
                  onError("Server Error: " + _status2);
                }
              }
              decoder = new TextDecoder("utf-8");
              reader = response.body.getReader(); //create a stream reader for the response body
            case 26:
              if (!true) {
                _context3.next = 39;
                break;
              }
              _context3.next = 29;
              return reader.read();
            case 29:
              _yield$reader$read2 = _context3.sent;
              done = _yield$reader$read2.done;
              value = _yield$reader$read2.value;
              if (!done) {
                _context3.next = 35;
                break;
              }
              progressCallback(true, "Done");
              return _context3.abrupt("return");
            case 35:
              result = decoder.decode(value); //decode to text
              progressCallback(false, result);
              _context3.next = 26;
              break;
            case 39:
              _context3.next = 45;
              break;
            case 41:
              _context3.prev = 41;
              _context3.t0 = _context3["catch"](8);
              console.log(_context3.t0);
              if (onError) {
                onError("Request Failed: " + _context3.t0.toString());
              }
            case 45:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[8, 41]]);
      }));
      return function (_x3, _x4, _x5, _x6) {
        return _ref3.apply(this, arguments);
      };
    }());
    /**
     * Download's a file asynchronously, and saves it to the user's Download folder
     * Call GET REST method securely, passing the Oauth2 bearer token and the CSRF token. The REST API is expected to 
     * blob response  (200 OK).
     * 
     * @param {String} path the REST path 
     * @param {String} filename the name of the file to create
     * @param {Function} doneCallback function to be called when download is complete (before saving to users's download dir)
     * @param {Function} onError function to be called when an error occurs, the error message passed as a String
     * @param {String} queryString the query part which must already be URI encoded, appended to path with encoding (not required)
     */
    _defineProperty(_this, "secureFileDownload", /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(path, filename, doneCallback, onError) {
        var queryString,
          opts,
          offset,
          tz,
          uri,
          response,
          status,
          file,
          _args4 = arguments;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              queryString = _args4.length > 4 && _args4[4] !== undefined ? _args4[4] : null;
              //Add the bearer token and csrf header to the options (CSRF not necessary for GET requests, but doesn't hurt)
              opts = {
                method: "GET",
                credentials: 'include',
                headers: {
                  "X-XSRF-TOKEN": _this._csrfToken
                },
                redirect: "manual"
              }; //Let the server know what timezone we are in (for actions that cause server to generate timestamps)
              //The time-zone offset is the difference, in minutes, between UTC and local time. Note that this means that the offset is positive if the local timezone is behind UTC and negative if it is ahead. For example, if your time zone is UTC+10 (Australian Eastern Standard Time), -600 will be returned.
              offset = new Date().getTimezoneOffset();
              opts.headers["timezone-offset"] = offset.toString();
              tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
              opts.headers["timezone"] = tz;
              _context4.prev = 6;
              uri = encodeURI(path);
              if (queryString !== null) uri = uri + queryString;
              console.log("File Download: " + uri);
              _context4.next = 12;
              return fetch(uri, opts);
            case 12:
              response = _context4.sent;
              if (!(response.type === "opaqueredirect")) {
                _context4.next = 16;
                break;
              }
              _this._handleRedirect();
              return _context4.abrupt("return");
            case 16:
              if (response.ok) {
                _context4.next = 21;
                break;
              }
              status = "Server Error: " + response.statusText;
              console.log(status);
              if (onError) {
                onError("Server Error: " + status);
              }
              return _context4.abrupt("return");
            case 21:
              _context4.next = 23;
              return response.blob();
            case 23:
              file = _context4.sent;
              if (doneCallback) doneCallback();
              (0, _jsFileDownload["default"])(file, filename);
              _context4.next = 32;
              break;
            case 28:
              _context4.prev = 28;
              _context4.t0 = _context4["catch"](6);
              console.log(_context4.t0);
              if (onError) {
                onError("Request Failed: " + _context4.t0.toString());
              }
            case 32:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[6, 28]]);
      }));
      return function (_x7, _x8, _x9, _x10) {
        return _ref4.apply(this, arguments);
      };
    }());
    /**
     * Call fetch to a third party (insecure),  The REST API is expected to return a json response or null (200 OK) or an error.
     *      
     * The path can contain the full REST path plus query string, and it is encodeURI'ed.  To handle special query strings that need encodeURIComponent,
     * pass them instead in "queryString".  The query string is appended unaltered to the path.
     * 
     * @param {String} path the REST path to which a JSON response or null is returned, this can include queryString unless encodeURIComponent is required
     * @param {Object} options standard fetch options (headers are replaced). If body exists, json header is set to "application/json"
     * @param {Function} callback function to be called when fetch is complete (with the JSON response, or null if no response)
     * @param {Function} onError function to be called when an error occurs, the error message passed as a String
     * @param {String} queryString the query part which must already be URI encoded, appended to path with encoding (not required)
     */
    _defineProperty(_this, "JSONFetch", /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(path) {
        var options,
          callback,
          onError,
          queryString,
          opts,
          method,
          uri,
          response,
          body,
          errorMessage,
          json,
          _args5 = arguments;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              options = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : {};
              callback = _args5.length > 2 ? _args5[2] : undefined;
              onError = _args5.length > 3 ? _args5[3] : undefined;
              queryString = _args5.length > 4 && _args5[4] !== undefined ? _args5[4] : null;
              opts = _objectSpread(_objectSpread({}, options), {}, {
                credentials: 'omit',
                headers: {}
              }); //If a body exists, add the json header type
              if (options.body) {
                opts.headers["Content-Type"] = "application/json";
              }

              //Accept only json response
              opts.headers["Accept"] = "application/json";
              _context5.prev = 7;
              method = options.method ? options.method : "GET";
              uri = encodeURI(path);
              if (queryString !== null) uri = uri + queryString;
              console.log(method + ": " + uri);
              _context5.next = 14;
              return fetch(uri, opts);
            case 14:
              response = _context5.sent;
              _context5.next = 17;
              return response.text();
            case 17:
              body = _context5.sent;
              if (response.ok) {
                _context5.next = 24;
                break;
              }
              console.log("Server Error: " + response.status);
              errorMessage = "Unknown Error";
              if (body) {
                errorMessage = "Server Error " + response.status;
              }
              if (onError) {
                onError(errorMessage);
              }
              return _context5.abrupt("return");
            case 24:
              if (callback) {
                if (body) {
                  try {
                    json = JSON.parse(body); //this should parse properly, on success
                    callback(json);
                  } catch (parseError) {
                    onError("Invalid response from server");
                  }
                } else {
                  callback(null);
                }
              }
              _context5.next = 31;
              break;
            case 27:
              _context5.prev = 27;
              _context5.t0 = _context5["catch"](7);
              console.log(_context5.t0);
              if (onError) {
                onError("Request Failed: " + _context5.t0.toString());
              }
            case 31:
            case "end":
              return _context5.stop();
          }
        }, _callee5, null, [[7, 27]]);
      }));
      return function (_x11) {
        return _ref5.apply(this, arguments);
      };
    }());
    _this._csrfToken = props.cookies.get("XSRF-TOKEN"); //hold this token for fetch requests
    return _this;
  }
  _inherits(RestComponent, _AlertingComponent);
  return _createClass(RestComponent, [{
    key: "login",
    value:
    /**
     * User Action by pressing the LOGIN button
     * Attempt to login by accessing a protected resource - browser is redirected to OAuth login page
     * @param {String} providerName the name of the OAuth2 provider to use (default is "okta")
     */
    function login() {
      var providerName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "okta";
      var port = window.location.port ? ':' + window.location.port : '';
      if (port === ":3000") {
        port = ":8080"; //switch to 8080 if using yarn development port
      }
      console.log("Logging in with ", providerName);
      window.location.href = "//" + window.location.hostname + port + "/oauth2/authorization/" + providerName;
    }

    /**
     * User action by pressing the LOGOUT button
     * Logout - response indicates a link to follow after logout
     * @param {Function} didLogout callback function to call after logout success
     */
  }, {
    key: "logout",
    value: function logout(didLogout) {
      this.secureJSONFetch("/auth/logout", {
        method: "POST"
      }, function (response) {
        if (didLogout) didLogout();
        window.location.href = response.logoutUrl;
      }, function (error) {
        console.error(error);
      });
    }
  }]);
}(_AlertingComponent2.AlertingComponent);
_defineProperty(RestComponent, "contextType", _HomepageContext.HomepageContext);
/**
 * Get a secure, random hex string of a specified length
 * @param {Number} len should be a even number, 2 or more
 * @returns {String} secure hex number
 */
_defineProperty(RestComponent, "secureRandom", function (len) {
  var dec2hexStr = function dec2hexStr(dec) {
    return dec.toString(16).padStart(2, "0");
  };
  var arr = new Uint8Array(len / 2);
  window.crypto.getRandomValues(arr);
  return Array.from(arr, dec2hexStr).join('');
});